import {StepPayload} from '@blesk-frontend/api';
import {cursorSVG, drawBlur, drawRect} from '../../spotlight/libs';
import {Rect} from '../types';
import {scaleRect} from './scaleRect';

interface ScaledChangesProps {
  step: StepPayload;
  rects: Rect[];
}

export const scaleChanges = async ({
  step,
  rects,
}: ScaledChangesProps): Promise<{blob: Blob | null; scaledRects: Rect[] | null}> => {
  let scaledRects: Rect[] | null = null;
  const img: HTMLImageElement | null = window.document.querySelector(
    'img[data-editor-image="true"]',
  );

  if (!img || !step?.src.edited) {
    return {blob: null, scaledRects};
  }

  const fullImg = new Image();
  fullImg.src = step.src.edited;
  try {
    await fullImg.decode();
  } catch (e) {
    console.error(e);
  }

  const scale = {
    x: fullImg.width / img.clientWidth,
    y: fullImg.height / img.clientHeight,
  };

  scaledRects = rects.map((r) => scaleRect(r, scale));

  const canvas = document.createElement('canvas');
  canvas.width = fullImg.width;
  canvas.height = fullImg.height;

  const ctx = canvas.getContext('2d');

  if (!ctx) {
    return {blob: null, scaledRects};
  }

  const cursorImage = await cursorSVG();

  ctx.drawImage(fullImg, 0, 0);

  scaledRects.forEach((rect) => {
    ctx.filter = 'none';
    ctx.fillStyle = 'rgba(0, 0, 0, 0)';
    ctx.shadowBlur = 0;
    ctx.shadowColor = 'rgba(0, 0, 0, 0)';
    ctx.strokeStyle = 'rgba(0, 0, 0, 0)';

    if (rect.type === 'highlight' || rect.type === 'circle') {
      drawRect(ctx, rect, rect.type === 'circle' ? cursorImage : undefined);
    }
    if (rect.type === 'blur') {
      drawBlur(ctx, rect, canvas);
    }
  });

  const blob = await new Promise<Blob | null>((resolve) => {
    canvas.toBlob((blob) => resolve(blob), 'image/webp', 0.9);
  });

  return {blob, scaledRects};
};
